import { PureComponent } from 'react';
import { connect } from 'react-redux';

import ProductInformation from 'Component/ProductInformation/ProductInformation.component';

export const mapStateToProps = (state) => ({
    code: state.ConfigReducer.code
});

export class ProductInformationContainer extends PureComponent {
    render() {
        return <ProductInformation {...this.props} />
    }
}

export default connect(mapStateToProps)(ProductInformationContainer);
